import React, { Component } from 'react';
import { number, func, string, bool, object } from 'prop-types';
import moment from 'moment';
import { join, omit } from 'lodash';
import Button from '@material-ui/core/Button';

import { withGroupContext } from 'context/groupContext';
import convertGroupIdToLabel from 'helpers/convertGroupIdToLabel';

import {
  IconWrapper,
  BulletIcon,
} from 'components/Annotations/Annotation/Annotation.style';
import {
  StyledListItem,
  Row,
  DateAndGroup,
  ButtonWrapper,
  StyledAnnotationDetails,
  Label,
  TextInput,
  Textarea,
  Text,
} from './AddAnnotation.style';

class AddAnnotation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: null,
      shortDescription: null,
    };
  }

  // Saves input from form to the state
  handleChange(key, value) {
    this.setState({ [key]: value });
  }

  handleCreateAnnotation = () => {
    const {
      date,
      startDate,
      endDate,
      activeGroups,
      showReference,
      referenceId,
    } = this.props;
    const { title, shortDescription } = this.state;

    /**
     * If reference id is disabled, remove it from the groups when creating a call.
     */
    const groups = showReference
      ? activeGroups
      : omit(activeGroups, referenceId);

    this.props.onCreateAnnotation({
      type: 'manual',
      timestamp: date,
      title: title,
      short_description: shortDescription,
      time_selection: { from: startDate / 1000, to: endDate / 1000 },
      payload: null,
      groups,
    });
  };

  render() {
    const {
      date,
      activeGroupIds,
      startDate,
      endDate,
      showReference,
      referenceId,
    } = this.props;
    const groupList = activeGroupIds
      .filter(key => !(!showReference && key === referenceId))
      .map(group => convertGroupIdToLabel(group));
    const dateRangeFrom = moment(startDate).format('YYYY-MM-DD');
    const dateRangeTo = moment(endDate).format('YYYY-MM-DD');

    return (
      <StyledListItem>
        <Row>
          <IconWrapper>
            <BulletIcon />
          </IconWrapper>
          <DateAndGroup>
            {moment(date * 1000).format('YYYY-MM-DD')} - {join(groupList, ', ')}
          </DateAndGroup>
          <ButtonWrapper>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.handleCreateAnnotation}
            >
              Add Annotation
            </Button>
          </ButtonWrapper>
        </Row>
        <StyledAnnotationDetails>
          <Label>Date range</Label>
          <Text>{`${dateRangeFrom} - ${dateRangeTo}`}</Text>
          <Label>Title</Label>
          <TextInput
            id="add-annotation-title"
            name="add-annotation-title"
            placeholder="Type title here..."
            autoFocus="true"
            onChange={event => this.handleChange('title', event.target.value)}
          />
          <Label>Description</Label>
          <Textarea
            id="add-annotation-text"
            name="add-annotation-text"
            placeholder="Type description here..."
            onChange={event =>
              this.handleChange('shortDescription', event.target.value)
            }
          />
        </StyledAnnotationDetails>
      </StyledListItem>
    );
  }
}

AddAnnotation.propTypes = {
  activeGroups: object.isRequired,
  date: number.isRequired,
  onCreateAnnotation: func.isRequired,
  startDate: number.isRequired,
  endDate: number.isRequired,
  showReference: bool,
  referenceId: string.isRequired,
};

export default withGroupContext(AddAnnotation);



// WEBPACK FOOTER //
// ./src/components/Annotations/AddAnnotation/AddAnnotation.js